/** Города */
export const MOSCOW = 1;
export const SPB = 2;
export const NN = 4885; // Нижний Новгород

/** Области */
export const MOSCOW_REGION = 4593;
export const SPB_REGION = 4588;
export const NN_REGION = 4596;
export const TATARSTAN_REGION = 4618;
export const KRASNOYARSK_REGION = 4585;
export const VORONEZH_REGION = 4567;

export const MOSCOW_AND_AREA = -1;
export const ST_PETERSBURG_AND_AREA = -2;

export const LOCATIONS_TO_REPLACE = {
  [MOSCOW]: MOSCOW_AND_AREA,
  [MOSCOW_REGION]: MOSCOW_AND_AREA,
  [SPB]: ST_PETERSBURG_AND_AREA,
  [SPB_REGION]: ST_PETERSBURG_AND_AREA,
};

export enum ERegions {
  moscow = MOSCOW,
  moscowRegion = MOSCOW_REGION,
  spb = SPB,
  spbRegion = SPB_REGION,
  ufa = 176245,
  bashkortostan = 4560,
  nizhniyNovgorod = NN,
  nizhniyNovgorodRegion = NN_REGION,
  rostovNaDony = 4959,
  rostovRegion = 4606,
  samara = 4966,
  samaraRegion = 4608,
  kazan = 4777,
  tatarstan = TATARSTAN_REGION,
  krasnodar = 4820,
  krasnodarRegion = 4584,
  vologda = 4708,
  vologdaRegion = 4566,
  ekaterinburg = 4743,
  sverdlovskRegion = 4612,
  kaluga = 4780,
  kalugaRegion = 4576,
}
